var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { "padding-left": "16px" } }, [
    _c("i", { class: "iconfont " + _vm.icon }),
    _vm._v(" "),
    _c("span", { attrs: { slot: "title" }, slot: "title" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }